<template>
    <div style="height: 100%;padding: 10px 20px;box-sizing: border-box" class="descriptionsForm">
        <div style="padding-bottom: 15px;">
            <el-page-header @back="close" :content="title+'酒店入住协议登记'"></el-page-header>
        </div>
        <el-row>
                <el-form :model="check" ref="check" label-width="90px" :inline="true">
                    <el-descriptions :column="3" border :labelStyle="{'width':'110px'}" >
                        <el-descriptions-item>
                            <template slot="label">
                                <span style="color: #F56C6C;margin-right: 4px;">*</span>入住店面
                            </template>
                            <el-form-item prop="hotelId">
                                <el-select size="mini" filterable v-model="check.hotelId" placeholder="请选择入住店面" >
                                    <el-option v-for="item in hotelList" :key="item.id" :label="item.name" :value="item.id" @click.native="setHotelName(item.name)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <span style="color: #F56C6C;margin-right: 4px;">*</span>入住协议
                            </template>
                            <el-form-item prop="hotelId">
                                <el-select size="mini" filterable v-model="check.agreementId" placeholder="请选择入住协议" >
                                    <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <span style="color: #F56C6C;margin-right: 4px;">*</span>房号
                            </template>
                            <el-form-item prop="houseName">
                                <el-input size="mini" maxlength="32" show-word-limit  v-model="check.houseName" placeholder="请输入房号" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" :column="1" border size="mini" :labelStyle="{'width':'110px'}">
                        <el-descriptions-item>
                            <template slot="label">
                                备注
                            </template>
                            <el-form-item prop="remark">
                                <el-input size="mini" maxlength="255" type="textarea" resize="none" :rows="3" v-model="check.remark" placeholder="请输入备注" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(sysCheckHistories,index) in check.sysCheckHistories">
                        <el-row style="padding: 10px;box-sizing: border-box">
                            <el-col :span="12">签约用户</el-col>
                            <el-col :span="12" style="text-align: right">
                                <el-button size="mini" @click="addCheck" v-if="(index+1)==check.sysCheckHistories.length">新增</el-button>
                                <el-button size="mini" @click="removeCheck(index)" v-if="check.sysCheckHistories.length>1">删除</el-button>
                            </el-col>
                        </el-row>
                        <el-descriptions :column="4" border direction="vertical"  :labelStyle="{'width':'110px'}">
                            <el-descriptions-item>
                                <template slot="label">
                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>姓名
                                </template>
                                <el-form-item :prop="'sysCheckHistories.' + index + '.name'" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
                                    <el-input size="mini" maxlength="10" show-word-limit v-model="sysCheckHistories.name" placeholder="请输入姓名" auto-complete="off"></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="身份证号">
                                <template slot="label">
                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>身份证号
                                </template>
                                <el-form-item :prop="'sysCheckHistories.' + index + '.idCard'" :rules="[{required: true, message: '身份证号不能为空', trigger: 'blur'},{min:18,max:18,message: '身份证号必须为18位', trigger: 'blur'}]">
                                    <el-input size="mini" maxlength="18" show-word-limit v-model="sysCheckHistories.idCard" placeholder="请输入身份证号" auto-complete="off"></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="联系方式">
                                <template slot="label">
                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>联系方式
                                </template>
                                <el-form-item :prop="'sysCheckHistories.' + index + '.phone'" :rules="[{required: true, message: '联系方式不能为空', trigger: 'blur'},{min:11,max:11,message: '联系方式必须为11位', trigger: 'blur'}]">
                                    <el-input size="mini" maxlength="11" show-word-limit v-model="sysCheckHistories.phone" placeholder="请输入联系方式" auto-complete="off"></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="身份证正面">
                                <template slot="label">
                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>身份证正面
                                </template>
                                <el-form-item  :prop="'sysCheckHistories.' + index + '.idCardFrontImg'" :rules="{required: true, message: '身份证正面照片为空', trigger: 'blur'}">
                                    <el-upload
                                            class="el-uploader"
                                            :headers="{token:$store.getters.getToken}"
                                            :action="uploadCheckUrl"
                                            :show-file-list="false"
                                            :on-progress="checkUploadProgress"
                                            :on-success="uploadIdCardFrontImgSuccess.bind(null,{'index':index})"
                                            :on-error="uploadCheckError"
                                            :before-upload="beforeCheckUpload"
                                            accept ='.png,.jpg,.tif,.JPEG'>
                                        <img v-if="sysCheckHistories.idCardFrontImg" :src="config.resPre+sysCheckHistories.idCardFrontImg" class="uploader-img">
                                        <i v-else class="el-icon-plus el-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-descriptions-item>
<!--                            <el-descriptions-item label="健康码">-->
<!--                                <template slot="label">-->
<!--                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>健康码-->
<!--                                </template>-->
<!--                                <el-form-item  :prop="'sysCheckHistories.' + index + '.healthCodeImg'" :rules="{required: true, message: '健康码照片为空', trigger: 'blur'}">-->
<!--                                    <el-upload-->
<!--                                            class="el-uploader"-->
<!--                                            :headers="{token:$store.getters.getToken}"-->
<!--                                            :action="uploadCheckUrl"-->
<!--                                            :show-file-list="false"-->
<!--                                            :on-progress="checkUploadProgress"-->
<!--                                            :on-success="uploadHealthCodeImgSuccess.bind(null,{'index':index})"-->
<!--                                            :on-error="uploadCheckError"-->
<!--                                            :before-upload="beforeCheckUpload"-->
<!--                                            accept ='.png,.jpg,.tif,.JPEG'>-->
<!--                                        <img v-if="sysCheckHistories.healthCodeImg" :src="config.resPre+sysCheckHistories.healthCodeImg" class="uploader-img">-->
<!--                                        <i v-else class="el-icon-plus el-uploader-icon"></i>-->
<!--                                    </el-upload>-->
<!--                                </el-form-item>-->
<!--                            </el-descriptions-item>-->
                            <!--<el-descriptions-item label="身份证反面">
                                <template slot="label">
                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>身份证反面
                                </template>
                                <el-form-item  :prop="'sysCheckHistories.' + index + '.idCardReverseImg'" :rules="{required: true, message: '身份证反面照片为空', trigger: 'blur'}">
                                    <el-upload
                                            class="el-uploader"
                                            :headers="{token:$store.getters.getToken}"
                                            :action="uploadCheckUrl"
                                            :show-file-list="false"
                                            :on-progress="checkUploadProgress"
                                            :on-success="uploadIdCardReverseImgSuccess.bind(null,{'index':index})"
                                            :on-error="uploadCheckError"
                                            :before-upload="beforeCheckUpload"
                                            accept ='.png,.jpg,.tif,.JPEG'>
                                        <img v-if="sysCheckHistories.idCardReverseImg" :src="config.resPre+sysCheckHistories.idCardReverseImg" class="uploader-img">
                                        <i v-else class="el-icon-plus el-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="行程码">
                                <template slot="label">
                                    <span style="color: #F56C6C;margin-right: 4px;">*</span>行程码
                                </template>
                                <el-form-item :prop="'sysCheckHistories.' + index + '.runCodeImg'" :rules="{required: true, message: '行程码照片为空', trigger: 'blur'}">
                                    <el-upload
                                            class="el-uploader"
                                            :headers="{token:$store.getters.getToken}"
                                            :action="uploadCheckUrl"
                                            :show-file-list="false"
                                            :on-progress="checkUploadProgress"
                                            :on-success="uploadRunCodeImgSuccess.bind(null,{'index':index})"
                                            :on-error="uploadCheckError"
                                            :before-upload="beforeCheckUpload"
                                            accept ='.png,.jpg,.tif,.JPEG'>
                                        <img v-if="sysCheckHistories.runCodeImg" :src="config.resPre+sysCheckHistories.runCodeImg" class="uploader-img">
                                        <i v-else class="el-icon-plus el-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-descriptions-item>-->
                        </el-descriptions>
                    </div>
                    <div class="sign" style="margin-bottom: 60px;">
                        <div style="padding: 10px 10px;box-sizing: border-box;">
                            <div style="font-size: 22px;font-weight: bold;">请签字确认并提交</div>
                        </div>
                        <sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value"/>
                        <div class="btnList" ref="btnList">
                            <el-button type="danger" size="small" @click="clearSignImg">清空</el-button>
                            <el-button type="primary" size="small" class="ml30 mr30" @click="saveSignImg('check')">提交</el-button>
                            <el-button type="primary" size="small" @click="close">返回</el-button>
                        </div>
                    </div>
                </el-form>
            </el-row>
    </div>
</template>

<script>
    import axios from 'axios';
    let loading;
    export default {
        name: 'saveOrUpdateSysCheck',
        props:['title','id'],
        data() {
            return {
                canClick:true, // 验证码是否禁用
                totalTime:3,
                buttonText:'',
                check:{
                    adminId: '',
                    adminName: '',
                    agreementId: '',
                    hotelId: '',
                    hotelName: '',
                    houseName: '',
                    names: '',
                    phones: '',
                    idCards: '',
                    userAgent: '',
                    browser: '',
                    os: '',
                    status: '',
                    startTime: '',
                    endTime: '',
                    days: '',
                    writeName: '',
                    claimTime: '',
                    claimAdminId: '',
                    claimAdminName: '',
                    remark:'',
                    updateTime: '',
                    createTime: '',
                    sysCheckHistories:[
                        {
                            id:'',
                            checkId:'',
                            name:'',
                            idCard:'',
                            phone:'',
                            idCardFrontImg:'',
                            idCardReverseImg:'',
                            healthCodeImg:'',
                            runCodeImg:'',
                            updateTime:'',
                            createTime:''
                        }
                    ]
                },
                config:config,
                uploadCheckUrl:`${home}/sysDdList/uploadCheck`,
                value: null,
                //配置
                options: {
                    lastWriteSpeed: 1, //书写速度 [Number] 可选
                    lastWriteWidth: 2, //下笔的宽度 [Number] 可选
                    lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
                    lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                    canvasWidth: "800", //canvas宽高 [Number] 可选
                    canvasHeight: "650", //高度  [Number] 可选
                    isShowBorder: false, //是否显示边框 [可选]
                    bgColor: "#fcc", //背景色 [String] 可选
                    borderWidth: 1, // 网格线宽度  [Number] 可选
                    borderColor: "#ff787f", //网格颜色  [String] 可选
                    writeWidth: 5, //基础轨迹宽度  [Number] 可选
                    maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
                    minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                    writeColor: "#101010", // 轨迹颜色  [String] 可选
                    isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                    imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
                },
                hotelList:[],
                agreementList:[],
            }
        },
        created() {
            if (this.title == '修改') {
                axios({
                    url: `${home}/sysCheck/update/findSysCheckById/${this.id}`,
                    method: 'GET'
                }).then(res => {
                    Object.assign(this.check, res.data);
                    if(this.check.startTime && this.check.endTime){
                        this.check.startTime = (this.check.startTime+"~"+this.check.endTime).split("~");
                    }
                    this.value = res.data.writeName;
                }).catch(error => {

                })
            }
            this.findHotelList();

        },
        mounted() {
            let windowHeight = document.documentElement.clientHeight;
            let btnList = this.$refs.btnList.offsetHeight;
            let windowWidth = document.documentElement.clientWidth;
            this.options.canvasWidth = windowWidth;
            this.options.canvasHeight = windowHeight - btnList;
        },
        methods: {
            checkUploadProgress(event, file, fileList){

            },
            uploadCheckError(err, file, fileList){
                loading.close();
            },
            beforeCheckUpload(file){
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            uploadIdCardFrontImgSuccess(obj, response, file){
                this.check.sysCheckHistories[obj.index].idCardFrontImg=response;
                loading.close();
            },
            uploadIdCardReverseImgSuccess(obj, response, file){
                this.check.sysCheckHistories[obj.index].idCardReverseImg=response;
                loading.close();
            },
            uploadHealthCodeImgSuccess(obj, response, file){
                this.check.sysCheckHistories[obj.index].healthCodeImg=response;
                loading.close();
            },
            uploadRunCodeImgSuccess(obj, response, file){
                this.check.sysCheckHistories[obj.index].runCodeImg=response;
                loading.close();
            },
            addCheck(){
                this.check.sysCheckHistories.push(
                    {
                        id:'',
                        checkId:'',
                        name:'',
                        idCard:'',
                        phone:'',
                        idCardFrontImg:'',
                        idCardReverseImg:'',
                        healthCodeImg:'',
                        runCodeImg:'',
                        updateTime:'',
                        createTime:''
                    }
                );
            },
            removeCheck(index) {
                this.check.sysCheckHistories.splice(index, 1);

            },
            //清除画板
            clearSignImg() {
                this.$refs.SignCanvas.canvasClear();
                // this.$refs['Check'].resetFields();
            },
            // 保存图片
            saveSignImg(formName) {
                console.log(this.value,"===========");
                if (this.value == null) {
                    this.$message.error("请先签名");
                } else {
                    this.$confirm('请先确认签名是否正确,一旦签名成功，无法撤销?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                this.check.writeName = this.value;
                                if(this.check.startTime){
                                    this.check.endTime = this.check.startTime[1];
                                    this.check.startTime = this.check.startTime[0];
                                }
                                axios({
                                    url: `${home}/sysCheck/${this.title==='增加'?'saveCheck':'updateCheck'}`,
                                    method: "POST",
                                    data: this.check
                                }).then(res => {
                                    this.$message({
                                        type: 'success',
                                        message: '操作成功!'
                                    });
                                    this.close();
                                }).catch(error => {
                                });
                            }
                        });
                    }).catch(e => {
                        this.$message({
                            type: 'info',
                            message: '签名取消,请重新签名'
                        });
                        this.$refs.SignCanvas.canvasClear();
                    });
                }
            },
            //下载图片/
            // downloadSignImg() {
            //   this.$refs.SignCanvas.downloadSignImg();
            // },
            back() {
                this.$router.back(-1);
            },
            findHotelList(){
                axios({
                    url: `${home}/sysHotel/findMyHotelList`,
                    method: "GET",
                }).then(res => {
                    this.hotelList = res.data;
                }).catch(error => {
                });
            },
            close(){
                this.$emit('closeSaveOrUpdate');
            },
            setHotelName(title){
                this.check.hotelName = title;
            },
        }
    }
</script>

<style scoped lang="scss">
    .descriptionsForm{
        .el-form-item__content{
            width: 100% !important;
        }
        .el-form-item {
            width: 100% !important;
        }
        .el-select {
            width: 100% !important;
        }
        .el-input-number--mini {
            width: 100% !important;
        }
        .el-date-editor.el-input, .el-date-editor .el-input__inner {
            width: 100% !important;
            border-top: none !important;
        }
        .contents{
            height: 30px !important;
            line-height: 30px !important;
        }
        .i.el-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 290px !important;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
    }

</style>
<style lang="scss" scoped>
    .btnList {
        width: 100%;
        padding: 15px 0;
        display: flex;
        justify-content: center;
        position: fixed;
        bottom: 0;
    }

    .sign-canvas {
        width: 100%;

        display: block;
        margin: 0 auto;
        background: #F1F1F1 !important;
        border-radius: 8px;
    }

</style>

